import React from 'react';

const FlashMessageContext = React.createContext(() => {
    throw new Error('Used FlashMessageContext.Consumer without a Provider');
});
const { Provider, Consumer } = FlashMessageContext;

export default FlashMessageContext;
export { Provider, Consumer };
